module.exports = "<div class=\"panel-group\">\n    <slot></slot>\n  </div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Accordion.vue
// module id = 94
// module chunks = 0